import React from "react";
import { motion } from "framer-motion";
import SafeIcon from "../common/SafeIcon";
import * as FiIcons from "react-icons/fi";

const { FiAward, FiUsers, FiTrendingUp, FiMic, FiFileText } = FiIcons;

const Hero = () => {
  return (
    <section
      id="hero"
      className="pt-16 bg-gradient-to-br from-blue-50 to-indigo-100 min-h-screen flex items-center"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
          >
            <div className="inline-flex items-center bg-blue-100 text-blue-800 px-4 py-2 rounded-full text-sm font-medium mb-6">
              <SafeIcon icon={FiAward} className="mr-2 h-4 w-4" />
              Certification RNCP37275
            </div>

            <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
              FORMATEUR PROFESSIONNEL D'ADULTES
            </h1>

            <p className="text-xl text-gray-600 mb-8 leading-relaxed">
              Devenir formateur pour adultes, c'est choisir un métier utile et
              valorisant qui permet de mettre son expérience au service des
              autres et d'accompagner concrètement des apprenants dans leur
              évolution professionnelle.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-12">
              <a
                href="/DECISION 54-25-688 FPA. ADVOCACI GROUPE SITE NANCY.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center bg-blue-600 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-blue-700 transition-colors duration-200"
              >
                <SafeIcon icon={FiFileText} className="mr-2 h-5 w-5" />
                Organisme de Formation agréé
              </a>
              <button className="border-2 border-blue-600 text-blue-600 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-blue-50 transition-colors duration-200">
                01 83 79 02 87
              </button>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-8">
              <div className="text-center">
                <div className="text-3xl font-bold text-blue-600">144h</div>
                <div className="text-gray-600">de formation</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-blue-600">4</div>
                <div className="text-gray-600">parcours disponibles</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-blue-600">100%</div>
                <div className="text-gray-600">finançable</div>
              </div>
            </div>
          </motion.div>

          {/* Visual */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="relative"
          >
            <div className="bg-white rounded-2xl shadow-2xl p-8 relative z-10">
              <div className="space-y-6">
                <div className="flex items-center space-x-4">
                  <div className="bg-blue-100 p-3 rounded-lg">
                    <SafeIcon
                      icon={FiUsers}
                      className="h-6 w-6 text-blue-600"
                    />
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900">
                      Accompagnement VAE
                    </h3>
                    <p className="text-gray-600">À partir de 2 800€</p>
                  </div>
                </div>

                <div className="flex items-center space-x-4">
                  <div className="bg-green-100 p-3 rounded-lg">
                    <SafeIcon
                      icon={FiTrendingUp}
                      className="h-6 w-6 text-green-600"
                    />
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900">
                      Université d'été
                    </h3>
                    <p className="text-gray-600">À partir de 3 200€</p>
                  </div>
                </div>

                <div className="flex items-center space-x-4">
                  <div className="bg-orange-100 p-3 rounded-lg">
                    <SafeIcon
                      icon={FiMic}
                      className="h-6 w-6 text-orange-600"
                    />
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900">
                      Pack Expert (VAE + Éloquence)
                    </h3>
                    <p className="text-gray-600">À partir de 4 000€</p>
                  </div>
                </div>

                <div className="flex items-center space-x-4">
                  <div className="bg-purple-100 p-3 rounded-lg">
                    <SafeIcon
                      icon={FiAward}
                      className="h-6 w-6 text-purple-600"
                    />
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900">
                      Sessions Longues
                    </h3>
                    <p className="text-gray-600">À partir de 4 500€</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Decorative elements */}
            <div className="absolute -top-4 -right-4 w-72 h-72 bg-blue-200 rounded-full opacity-20"></div>
            <div className="absolute -bottom-4 -left-4 w-56 h-56 bg-indigo-200 rounded-full opacity-20"></div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
